<template>
  <v-btn color="red--text" @click="$emit('click')" v-bind="$attrs" :loading="loading">
    <v-icon left>mdi-delete</v-icon>
    {{ activeLabel }}
  </v-btn>
</template>

<script>
export default {
  name: 'DeleteButton',
  props: ['label', 'loading'],
  computed: {
    activeLabel () {
      if (this.label) {
        return this.label;
      } else {
        return this.$t('general.delete');
      }
    }
  }
}
</script>
